// @ts-nocheck
import cn from "classnames";
import {
  IonInput
} from '@ionic/react';
import {WidgetInput} from 'react-addressfinder'
import './AddressAutocomplete.css'

const AddressAutocomplete: React.FC = props => {
  
  const {initialAddress = '', disabled = false, onAddressUpdate = ()=>{}} = props;
  
  return (
      <>
        {disabled ?
        <IonInput
          className={cn('settings-content-input', 'disabled')}
          value={initialAddress}
          type="text"
          required
        />
        :
        <WidgetInput
          addressFinderKey={'XCPGU9KHF4MWLYD8ERNT'}
          id={'addressWidget'}
          className={cn('settings-content-input', 'active')}
          placeholder={initialAddress}
          onSelected={fullAddress => onAddressUpdate(fullAddress)}
        />
        }
      </>
  )
}

export default AddressAutocomplete;
